import { Button, ModalV3, useTranslation } from '@helios/frontend-core';
import { useEffect, useState } from 'react';
import { useUser } from '../../../api/user/useUser';
import { applyPendingUpdate, setLateUpdateListener } from '../../../utils/initialLiveUpdateSync';

const TRACKING_ID = 'live-update-prompt';

export const LiveUpdatePrompt = () => {
  const { t } = useTranslation();
  const { isAuthenticated } = useUser();
  const [isUpdateAvailable, setIsUpdateAvailable] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const [isApplying, setIsApplying] = useState(false);

  useEffect(() => {
    setLateUpdateListener(() => setIsUpdateAvailable(true));
    return () => setLateUpdateListener(null);
  }, []);

  const isOpen = isUpdateAvailable && isAuthenticated && !isDismissed;

  if (!isOpen) return null;

  const handleUpdateNow = async () => {
    setIsApplying(true);
    await applyPendingUpdate();
    setIsApplying(false);
  };

  const cta = (
    <div className="flex flex-col gap-8 w-full">
      <Button
        trackingId={`${TRACKING_ID}-update-now-button`}
        emphasis="primary"
        layout="fill"
        loading={isApplying}
        onClick={handleUpdateNow}
      >
        {t('liveUpdatePrompt.updateNow')}
      </Button>
      <Button
        trackingId={`${TRACKING_ID}-later-button`}
        emphasis="secondary"
        layout="fill"
        onClick={() => setIsDismissed(true)}
      >
        {t('liveUpdatePrompt.later')}
      </Button>
    </div>
  );

  return (
    <ModalV3
      open={isOpen}
      onClose={() => setIsDismissed(true)}
      trackingId={TRACKING_ID}
      cta={cta}
      showCloseButton={false}
    >
      <div className="flex flex-col gap-8 w-full">
        <p className="label-400 text-text-primary">{t('liveUpdatePrompt.heading')}</p>
        <p className="body-400 text-text-primary">{t('liveUpdatePrompt.body')}</p>
      </div>
    </ModalV3>
  );
};
